import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CadastroHelprevService } from '../service/cadastro-helprev.service';
import { take } from 'rxjs';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent {
  searchId!: string;
  isLoading: boolean = false;

  constructor(private translate: TranslateService,
    private cadastroHelprevService: CadastroHelprevService,
    private router: Router) { }

  changeLanguage(strLang: string) {
    this.translate.use(strLang)
  }

  async search(searchId: string) {

    this.isLoading = true;

//     let mock = {"id": "330939","canUpdate": true,"canDelete": true,"canArchive": true,"hasChildren": false,"info": [{"key": "resolution","value": "","valueClass": "","keyCaption": "Resolução","valueCaption": ""},{"key": "CustomColumn348sr","value": 1,"valueClass": "","keyCaption": "Classificação do relato","valueCaption": "Vulnerabilidade"},{"key": "CustomColumn347sr","value": 2,"valueClass": "","keyCaption": "Classificação em AVSEC","valueCaption": "Não"},{"key": "CustomColumn282sr","value": 1769439300000,"valueClass": "","keyCaption": "Data da ocorrência","valueCaption": "26-01-2026"},{"key": "CustomColumn349sr","value": null,"valueClass": "","keyCaption": "Data da Solução Relseg","valueCaption": ""},{"key": "CustomColumn273sr","value": "SysAid","valueClass": "","keyCaption": "Autor do Relato","valueCaption": "SysAid"},{"key": "CustomColumn274sr","value": "a","valueClass": "","keyCaption": "E-mail do Autor do Relato","valueCaption": "a"},{"key": "solution","value": "","valueClass": "","keyCaption": "Solução","valueCaption": ""},{"key": "CustomColumn281sr","value": "Teste","valueClass": "","keyCaption": "Descrição do relato","valueCaption": "Teste"},{"key": "CustomColumn275sr","value": "Teste","valueClass": "","keyCaption": "Empresas envolvidas","valueCaption": "Teste"},{"key": "CustomColumn277sr","value": "TESTE","valueClass": "","keyCaption": "Ponto de referência","valueCaption": "TESTE"},{"key": "CustomColumn288sr","value": "TESTE","valueClass": "","keyCaption": "Local do relato","valueCaption": "TESTE"},{"key": "CustomColumn278sr","value": "b","valueClass": "","keyCaption": "Empresa do Autor do Relato","valueCaption": "b"}]};
// mock.id = searchId;
//     this.router.navigateByUrl('/', {skipLocationChange: true}).then(() =>
//     {
//       this.isLoading = false;
//       this.router.navigate(['/','search', this.searchId], {state: {cadastro: mock}, replaceUrl: true});
//     }
//     );
// return;
//     console.log('acessou');

    this.cadastroHelprevService.find(this.searchId).pipe(take(1))
      .subscribe({
        next: (response: any) => {
          if(!response.length){
            this.translate.get('EVENTO NÃO LOCALIZADO').pipe(take(1)).subscribe(res => Swal.fire('', res, 'error').then(() => this.isLoading = false));
            return;
          }

          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>{
            this.isLoading = false;
            this.router.navigate(['/', 'search', this.searchId], { state: { cadastro: response[0] }, replaceUrl: true });
          });
        },
        error: (erro: any) => this.translate.get('EVENTO NÃO LOCALIZADO').pipe(take(1)).subscribe(res => Swal.fire('', res, 'error').then(() => this.isLoading = false))
      })
  }

}
